import { FullBreedsList } from '../data/breed';
import { ExpensiveBreedList } from '../data/expensiveBreedList';

import type { BreedSchema } from '../types/breed';
import type { CatOrDog } from '../types/pet';

function getBaseListOfBreeds(): BreedSchema[] {
  return FullBreedsList;
}

// Main breed list is visible on the main view of the breed selection (usually with an Autocomplete-Input)
export function getMainBreedList({ catOrDog }: { catOrDog: CatOrDog }) {
  const breedType: BreedSchema['type'] = catOrDog === 'cat' ? 'cat' : 'dog';

  return getBaseListOfBreeds().filter(({ type, isMixed, isBaseCrossBreed }) =>
    Boolean(type === breedType && !isMixed && !isBaseCrossBreed),
  );
}

export function getMixedBreedList({ catOrDog }: { catOrDog: CatOrDog }) {
  const breedType: BreedSchema['type'] = catOrDog === 'cat' ? 'cat' : 'dog';

  return getBaseListOfBreeds().filter(({ type, isMixed }) => Boolean(type === breedType && isMixed));
}

export function getBaseCrossBreedList({ catOrDog }: { catOrDog: CatOrDog }) {
  const breedType: BreedSchema['type'] = catOrDog === 'cat' ? 'cat' : 'dog';

  return getBaseListOfBreeds().filter(({ type, isBaseCrossBreed }) => Boolean(type === breedType && isBaseCrossBreed));
}

export function getBreedList({
  catOrDog,
  breedClassToPick,
}: {
  catOrDog: CatOrDog | null;
  breedClassToPick?: 'mixed' | 'base-cross' | 'main';
}) {
  if (catOrDog === null) {
    return [];
  }

  let breedList: BreedSchema[];
  switch (breedClassToPick) {
    case 'mixed': {
      breedList = getMixedBreedList({ catOrDog });
      break;
    }
    case 'base-cross': {
      breedList = getBaseCrossBreedList({ catOrDog });
      break;
    }
    case 'main':
    default: {
      breedList = getMainBreedList({ catOrDog });
      break;
    }
  }

  return breedList.map(({ breedName, id }) => ({ value: breedName, label: breedName, id: id }));
}

export function findPetBreedByName(breedName: string) {
  return FullBreedsList.find((breed) => breed.breedName === breedName);
}

export function findPetBreedById(breedId: string) {
  return FullBreedsList.find((breed) => breed.id === breedId);
}

export function isExpensiveBreed(breedId: string) {
  return Boolean(ExpensiveBreedList.find((breed) => breed.id === breedId));
}
